import actions from './actions'
import articleManage from './metaData/am'
export default {
  state: {
    articleManage,
    actions
  }
}
